import { fromJS } from 'immutable'
import actionTypes from '../../actions/actionTypes'

const INIT_STATE = fromJS({
    searchResults: [],
    searchLoading: false,
    details: {},
    linkLoading: false,
    error: null
})

const tmdbDataReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case actionTypes.TMDB_SEARCH_REQUEST:
            return state.set('searchLoading', true).set('searchResults', fromJS([]))
        case actionTypes.TMDB_SEARCH_SUCCESS:
            return state.set('searchLoading', false).set('searchResults', fromJS(action.payload.results))
        case actionTypes.TMDB_SEARCH_FAILURE:
            return state.set('searchLoading', false).set('error', action.payload.error)
        case actionTypes.TMDB_DETAILS_SUCCESS:
            return state.setIn(['details', String(action.payload.tmdbId)], fromJS(action.payload.details))
        case actionTypes.TMDB_MATCH_REQUEST:
            return state.set('linkLoading', true)
        case actionTypes.TMDB_MATCH_SUCCESS:
            return state.set('linkLoading', false)
        case actionTypes.TMDB_MATCH_FAILURE:
            return state.set('linkLoading', false).set('error', action.payload.error)
        case actionTypes.TMDB_UNMATCH_REQUEST:
            return state.set('linkLoading', true)
        case actionTypes.TMDB_UNMATCH_SUCCESS:
            return state.set('linkLoading', false)
        case actionTypes.TMDB_UNMATCH_FAILURE:
            return state.set('linkLoading', false).set('error', action.payload.error)
        case actionTypes.TMDB_CLEAR:
            return state.set('searchResults', fromJS([])).set('searchLoading', false).set('error', null)
        default:
            return state
    }
}

export default tmdbDataReducer
